import { render, staticRenderFns } from "./ScreenCaptureOmatic.vue?vue&type=template&id=80036600&"
import script from "./ScreenCaptureOmatic.vue?vue&type=script&lang=js&"
export * from "./ScreenCaptureOmatic.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCaptureOmatic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports